import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageSenderService {
  value: any;
  private messageSource = new BehaviorSubject({});
  message$ = this.messageSource.asObservable();
  constructor() {}

  changeMessage(value: any) {
    this.messageSource.next(value);
  }
}
